import { Routes, Route, Navigate } from 'react-router-dom';
import useAuth from 'hooks/useAuth';

import IndexLayout from 'layouts/IndexLayout';
import MainLayout from 'layouts/MainLayout';
import AuthRoutes from 'components/AuthRoutes';
import IndexPage from 'pages/index/IndexPage';
import AccountgroupList from 'pages/accountgroup/List';
import AccountgroupView from 'pages/accountgroup/View';
import AccountgroupAdd from 'pages/accountgroup/Add';
import AccountgroupEdit from 'pages/accountgroup/Edit';
import AccountmasterList from 'pages/accountmaster/List';
import AccountmasterView from 'pages/accountmaster/View';
import AccountmasterAdd from 'pages/accountmaster/Add';
import AccountmasterEdit from 'pages/accountmaster/Edit';
import AccountpbmasterList from 'pages/accountpbmaster/List';
import AccountpbmasterView from 'pages/accountpbmaster/View';
import AccountpbmasterAdd from 'pages/accountpbmaster/Add';
import AccountpbmasterEdit from 'pages/accountpbmaster/Edit';
import AgentmasterList from 'pages/agentmaster/List';
import AgentmasterView from 'pages/agentmaster/View';
import AgentmasterAdd from 'pages/agentmaster/Add';
import AgentmasterEdit from 'pages/agentmaster/Edit';
import AgenttransactionList from 'pages/agenttransaction/List';
import AgenttransactionView from 'pages/agenttransaction/View';
import AgenttransactionAdd from 'pages/agenttransaction/Add';
import AgenttransactionEdit from 'pages/agenttransaction/Edit';
import AlertvwList from 'pages/alertvw/List';
import AlertvwView from 'pages/alertvw/View';
import AllsummaryvwList from 'pages/allsummaryvw/List';
import ApplicationmasterList from 'pages/applicationmaster/List';
import ApplicationmasterView from 'pages/applicationmaster/View';
import ApplicationmasterAdd from 'pages/applicationmaster/Add';
import ApplicationmasterEdit from 'pages/applicationmaster/Edit';
import ApplicationmasterAppstep2 from 'pages/applicationmaster/Appstep2';
import ApplicationmasterAppstep1 from 'pages/applicationmaster/Appstep1';
import AreamasterList from 'pages/areamaster/List';
import AreamasterView from 'pages/areamaster/View';
import AreamasterAdd from 'pages/areamaster/Add';
import AreamasterEdit from 'pages/areamaster/Edit';
import AssetmasterList from 'pages/assetmaster/List';
import AssetmasterView from 'pages/assetmaster/View';
import AssetmasterAdd from 'pages/assetmaster/Add';
import AssetmasterEdit from 'pages/assetmaster/Edit';
import AttendanceList from 'pages/attendance/List';
import AttendanceView from 'pages/attendance/View';
import AttendanceAdd from 'pages/attendance/Add';
import AttendanceEdit from 'pages/attendance/Edit';
import BalancevwList from 'pages/balancevw/List';
import BankList from 'pages/bank/List';
import BankView from 'pages/bank/View';
import BankAdd from 'pages/bank/Add';
import BankEdit from 'pages/bank/Edit';
import BatchesList from 'pages/batches/List';
import BatchesView from 'pages/batches/View';
import BatchesAdd from 'pages/batches/Add';
import BatchesEdit from 'pages/batches/Edit';
import BbpsbillervwList from 'pages/bbpsbillervw/List';
import BranchmasterList from 'pages/branchmaster/List';
import BranchmasterView from 'pages/branchmaster/View';
import BranchmasterAdd from 'pages/branchmaster/Add';
import BranchmasterEdit from 'pages/branchmaster/Edit';
import BranchtransactionList from 'pages/branchtransaction/List';
import BranchtransactionView from 'pages/branchtransaction/View';
import BranchtransactionAdd from 'pages/branchtransaction/Add';
import BranchtransactionEdit from 'pages/branchtransaction/Edit';
import CarryforwardcalculationvwList from 'pages/carryforwardcalculationvw/List';
import CodesettingList from 'pages/codesetting/List';
import CodesettingView from 'pages/codesetting/View';
import CodesettingAdd from 'pages/codesetting/Add';
import CodesettingEdit from 'pages/codesetting/Edit';
import CollectiontypevwList from 'pages/collectiontypevw/List';
import CreditreportList from 'pages/creditreport/List';
import CreditreportView from 'pages/creditreport/View';
import CreditreportAdd from 'pages/creditreport/Add';
import CreditreportEdit from 'pages/creditreport/Edit';
import CreditreportrawList from 'pages/creditreportraw/List';
import CreditreportrawView from 'pages/creditreportraw/View';
import CreditreportrawAdd from 'pages/creditreportraw/Add';
import CreditreportrawEdit from 'pages/creditreportraw/Edit';
import CreditreportsummaryList from 'pages/creditreportsummary/List';
import CreditreportsummaryView from 'pages/creditreportsummary/View';
import CreditreportsummaryAdd from 'pages/creditreportsummary/Add';
import CreditreportsummaryEdit from 'pages/creditreportsummary/Edit';
import CreditrequestList from 'pages/creditrequest/List';
import CreditrequestView from 'pages/creditrequest/View';
import CreditrequestAdd from 'pages/creditrequest/Add';
import CreditrequestEdit from 'pages/creditrequest/Edit';
import CredittblList from 'pages/credittbl/List';
import CredittblView from 'pages/credittbl/View';
import CredittblAdd from 'pages/credittbl/Add';
import CredittblEdit from 'pages/credittbl/Edit';
import CustdataList from 'pages/custdata/List';
import CustdataView from 'pages/custdata/View';
import CustdataAdd from 'pages/custdata/Add';
import CustdataEdit from 'pages/custdata/Edit';
import DemandlistvwList from 'pages/demandlistvw/List';
import DemandlistvwBranchlist from 'pages/demandlistvw/BranchList';
import DesignationmasterList from 'pages/designationmaster/List';
import DesignationmasterView from 'pages/designationmaster/View';
import DesignationmasterAdd from 'pages/designationmaster/Add';
import DesignationmasterEdit from 'pages/designationmaster/Edit';
import DistrictList from 'pages/district/List';
import DistrictView from 'pages/district/View';
import DistrictAdd from 'pages/district/Add';
import DistrictEdit from 'pages/district/Edit';
import DocumentmasterList from 'pages/documentmaster/List';
import DocumentmasterView from 'pages/documentmaster/View';
import DocumentmasterAdd from 'pages/documentmaster/Add';
import DocumentmasterEdit from 'pages/documentmaster/Edit';
import EmployeeleavehistoryvwList from 'pages/employeeleavehistoryvw/List';
import EmpmasterList from 'pages/empmaster/List';
import EmpmasterView from 'pages/empmaster/View';
import EmpmasterAdd from 'pages/empmaster/Add';
import EmpmasterEdit from 'pages/empmaster/Edit';
import EquistatesList from 'pages/equistates/List';
import EquistatesView from 'pages/equistates/View';
import EquistatesAdd from 'pages/equistates/Add';
import EquistatesEdit from 'pages/equistates/Edit';
import FixedaccountList from 'pages/fixedaccount/List';
import FixedaccountView from 'pages/fixedaccount/View';
import FixedaccountAdd from 'pages/fixedaccount/Add';
import FixedaccountEdit from 'pages/fixedaccount/Edit';
import GetemployeeleavebalancevwList from 'pages/getemployeeleavebalancevw/List';
import GrouploanamortList from 'pages/grouploanamort/List';
import GrouploanamortView from 'pages/grouploanamort/View';
import GrouploanamortAdd from 'pages/grouploanamort/Add';
import GrouploanamortEdit from 'pages/grouploanamort/Edit';
import GrouploancontractList from 'pages/grouploancontract/List';
import GrouploancontractView from 'pages/grouploancontract/View';
import GrouploancontractAdd from 'pages/grouploancontract/Add';
import GrouploancontractEdit from 'pages/grouploancontract/Edit';
import GrouploancontractBranchlist from 'pages/grouploancontract/BranchList';
import GrouploantransactionList from 'pages/grouploantransaction/List';
import GrouploantransactionView from 'pages/grouploantransaction/View';
import GrouploantransactionAdd from 'pages/grouploantransaction/Add';
import GrouploantransactionEdit from 'pages/grouploantransaction/Edit';
import HymarkfooterList from 'pages/hymarkfooter/List';
import HymarkheaderList from 'pages/hymarkheader/List';
import JournalmasterList from 'pages/journalmaster/List';
import JournalmasterView from 'pages/journalmaster/View';
import JournalmasterAdd from 'pages/journalmaster/Add';
import JournalmasterEdit from 'pages/journalmaster/Edit';
import JournalsList from 'pages/journals/List';
import JournalsView from 'pages/journals/View';
import JournalsAdd from 'pages/journals/Add';
import JournalsEdit from 'pages/journals/Edit';
import LeavecalendarreportvwList from 'pages/leavecalendarreportvw/List';
import LeavedetailsList from 'pages/leavedetails/List';
import LeavedetailsView from 'pages/leavedetails/View';
import LeavedetailsAdd from 'pages/leavedetails/Add';
import LeavedetailsEdit from 'pages/leavedetails/Edit';
import LeavemasterList from 'pages/leavemaster/List';
import LeavemasterView from 'pages/leavemaster/View';
import LeavemasterAdd from 'pages/leavemaster/Add';
import LeavemasterEdit from 'pages/leavemaster/Edit';
import LeaveperioddetailsList from 'pages/leaveperioddetails/List';
import LeaveperioddetailsView from 'pages/leaveperioddetails/View';
import LeaveperioddetailsAdd from 'pages/leaveperioddetails/Add';
import LeaveperioddetailsEdit from 'pages/leaveperioddetails/Edit';
import LeavetypemasterList from 'pages/leavetypemaster/List';
import LeavetypemasterView from 'pages/leavetypemaster/View';
import LeavetypemasterAdd from 'pages/leavetypemaster/Add';
import LeavetypemasterEdit from 'pages/leavetypemaster/Edit';
import LeaveutilizationsummaryvwList from 'pages/leaveutilizationsummaryvw/List';
import LoangroupList from 'pages/loangroup/List';
import LoangroupView from 'pages/loangroup/View';
import LoangroupAdd from 'pages/loangroup/Add';
import LoangroupEdit from 'pages/loangroup/Edit';
import LoanguarantorList from 'pages/loanguarantor/List';
import LoanguarantorView from 'pages/loanguarantor/View';
import LoanguarantorAdd from 'pages/loanguarantor/Add';
import LoanguarantorEdit from 'pages/loanguarantor/Edit';
import LoanproductList from 'pages/loanproduct/List';
import LoanproductView from 'pages/loanproduct/View';
import LoanproductAdd from 'pages/loanproduct/Add';
import LoanproductEdit from 'pages/loanproduct/Edit';
import LoanpurposeList from 'pages/loanpurpose/List';
import LoanpurposeView from 'pages/loanpurpose/View';
import LoanpurposeAdd from 'pages/loanpurpose/Add';
import LoanpurposeEdit from 'pages/loanpurpose/Edit';
import MandatedebitvwList from 'pages/mandatedebitvw/List';
import MandatedebitvwView from 'pages/mandatedebitvw/View';
import MandateworldList from 'pages/mandateworld/List';
import MandateworldView from 'pages/mandateworld/View';
import MandateworldAdd from 'pages/mandateworld/Add';
import MandateworldEdit from 'pages/mandateworld/Edit';
import MeetingcenterList from 'pages/meetingcenter/List';
import MeetingcenterView from 'pages/meetingcenter/View';
import MeetingcenterAdd from 'pages/meetingcenter/Add';
import MeetingcenterEdit from 'pages/meetingcenter/Edit';
import MembermasterList from 'pages/membermaster/List';
import MembermasterView from 'pages/membermaster/View';
import MembermasterAdd from 'pages/membermaster/Add';
import MembermasterEdit from 'pages/membermaster/Edit';
import NegativemasterList from 'pages/negativemaster/List';
import NegativemasterView from 'pages/negativemaster/View';
import NegativemasterAdd from 'pages/negativemaster/Add';
import NegativemasterEdit from 'pages/negativemaster/Edit';
import NewsList from 'pages/news/List';
import NewsView from 'pages/news/View';
import NewsAdd from 'pages/news/Add';
import NewsEdit from 'pages/news/Edit';
import NotifymasterList from 'pages/notifymaster/List';
import NotifymasterView from 'pages/notifymaster/View';
import NotifymasterAdd from 'pages/notifymaster/Add';
import NotifymasterEdit from 'pages/notifymaster/Edit';
import NotreceivedvwList from 'pages/notreceivedvw/List';
import OverduechargesList from 'pages/overduecharges/List';
import OverduechargesView from 'pages/overduecharges/View';
import OverduechargesAdd from 'pages/overduecharges/Add';
import OverduechargesEdit from 'pages/overduecharges/Edit';
import PaydetailsList from 'pages/paydetails/List';
import PaydetailsView from 'pages/paydetails/View';
import PaydetailsAdd from 'pages/paydetails/Add';
import PaydetailsEdit from 'pages/paydetails/Edit';
import PaygroupvwList from 'pages/paygroupvw/List';
import PaymasterList from 'pages/paymaster/List';
import PaymasterView from 'pages/paymaster/View';
import PaymasterAdd from 'pages/paymaster/Add';
import PaymasterEdit from 'pages/paymaster/Edit';
import PaytranvwList from 'pages/paytranvw/List';
import PermissionsList from 'pages/permissions/List';
import PermissionsView from 'pages/permissions/View';
import PermissionsAdd from 'pages/permissions/Add';
import PermissionsEdit from 'pages/permissions/Edit';
import PolicestationList from 'pages/policestation/List';
import PolicestationView from 'pages/policestation/View';
import PolicestationAdd from 'pages/policestation/Add';
import PolicestationEdit from 'pages/policestation/Edit';
import PreinterestdetlList from 'pages/preinterestdetl/List';
import PreinterestdetlView from 'pages/preinterestdetl/View';
import PreinterestdetlAdd from 'pages/preinterestdetl/Add';
import PreinterestdetlEdit from 'pages/preinterestdetl/Edit';
import RankmasterList from 'pages/rankmaster/List';
import RankmasterView from 'pages/rankmaster/View';
import RankmasterAdd from 'pages/rankmaster/Add';
import RankmasterEdit from 'pages/rankmaster/Edit';
import ReceivedvwList from 'pages/receivedvw/List';
import RelationmasterList from 'pages/relationmaster/List';
import RelationmasterView from 'pages/relationmaster/View';
import RelationmasterAdd from 'pages/relationmaster/Add';
import RelationmasterEdit from 'pages/relationmaster/Edit';
import RemoteipmasterList from 'pages/remoteipmaster/List';
import RemoteipmasterView from 'pages/remoteipmaster/View';
import RemoteipmasterAdd from 'pages/remoteipmaster/Add';
import RemoteipmasterEdit from 'pages/remoteipmaster/Edit';
import RolesList from 'pages/roles/List';
import RolesView from 'pages/roles/View';
import RolesAdd from 'pages/roles/Add';
import RolesEdit from 'pages/roles/Edit';
import SalarysheetList from 'pages/salarysheet/List';
import SalarysheetView from 'pages/salarysheet/View';
import SalarysheetAdd from 'pages/salarysheet/Add';
import SalarysheetEdit from 'pages/salarysheet/Edit';
import ScheduleexpiredvwList from 'pages/scheduleexpiredvw/List';
import SettingmasterList from 'pages/settingmaster/List';
import SettingmasterView from 'pages/settingmaster/View';
import SettingmasterAdd from 'pages/settingmaster/Add';
import SettingmasterEdit from 'pages/settingmaster/Edit';
import SmstempetesList from 'pages/smstempetes/List';
import SmstempetesView from 'pages/smstempetes/View';
import SmstempetesAdd from 'pages/smstempetes/Add';
import SmstempetesEdit from 'pages/smstempetes/Edit';
import StatesList from 'pages/states/List';
import StatesView from 'pages/states/View';
import StatesAdd from 'pages/states/Add';
import StatesEdit from 'pages/states/Edit';
import SubareamasterList from 'pages/subareamaster/List';
import SubareamasterView from 'pages/subareamaster/View';
import SubareamasterAdd from 'pages/subareamaster/Add';
import SubareamasterEdit from 'pages/subareamaster/Edit';
import TtList from 'pages/tt/List';
import UnitmasterList from 'pages/unitmaster/List';
import UnitmasterView from 'pages/unitmaster/View';
import UnitmasterAdd from 'pages/unitmaster/Add';
import UnitmasterEdit from 'pages/unitmaster/Edit';
import UsersList from 'pages/users/List';
import UsersView from 'pages/users/View';
import UsersAdd from 'pages/users/Add';
import UsersEdit from 'pages/users/Edit';
import VwclosingbalanceList from 'pages/vwclosingbalance/List';
import VwclosingbalanceBranchlist from 'pages/vwclosingbalance/BranchList';
import VwdemandcollectionbyperiodList from 'pages/vwdemandcollectionbyperiod/List';
import VwjournalsList from 'pages/vwjournals/List';
import VwjournalsallList from 'pages/vwjournalsall/List';
import VwloantransactionList from 'pages/vwloantransaction/List';
import VwmaxloanaccountList from 'pages/vwmaxloanaccount/List';
import VwonetimeoverduepreviewList from 'pages/vwonetimeoverduepreview/List';
import VwtrialbalanceList from 'pages/vwtrialbalance/List';
import WorkerlatestlocationList from 'pages/workerlatestlocation/List';
import WorkerlatestlocationView from 'pages/workerlatestlocation/View';
import WorkerlatestlocationAdd from 'pages/workerlatestlocation/Add';
import WorkerlatestlocationEdit from 'pages/workerlatestlocation/Edit';
import WorkerlocationsList from 'pages/workerlocations/List';
import WorkerlocationsView from 'pages/workerlocations/View';
import WorkerlocationsAdd from 'pages/workerlocations/Add';
import WorkerlocationsEdit from 'pages/workerlocations/Edit';
import NozonePage from 'pages/custom/NozonePage';
import LedgerstatementPage from 'pages/custom/LedgerstatementPage';
import EnachauthPage from 'pages/custom/EnachauthPage';
import LoanscheduePage from 'pages/custom/LoanscheduePage';
import LoanledgerPage from 'pages/custom/LoanledgerPage';
import GenerajournalPage from 'pages/custom/GenerajournalPage';
import TrialbalancePage from 'pages/custom/TrialbalancePage';
import BalancesheetPage from 'pages/custom/BalancesheetPage';
import ProfitPage from 'pages/custom/ProfitPage';
import LoanaeingPage from 'pages/custom/LoanaeingPage';
import LeavecaendarPage from 'pages/custom/LeavecaendarPage';
import KycupdatePage from 'pages/custom/KycupdatePage';
import GeodashboardPage from 'pages/custom/GeodashboardPage';
import JournalentPage from 'pages/custom/JournalentPage';
import DebitpresentationPage from 'pages/custom/DebitpresentationPage';
import DebitverifyPage from 'pages/custom/DebitverifyPage';
import MandateverifyPage from 'pages/custom/MandateverifyPage';
import SmsAlertPage from 'pages/custom/SmsAlertPage';
import SmsNotreceivePage from 'pages/custom/SmsNotreceivePage';
import SmsReceivedPage from 'pages/custom/SmsReceivedPage';
import DemandcollectionreportPage from 'pages/custom/DemandcollectionreportPage';
import CollectionPage from 'pages/home/CollectionPage';
import EmistatusPage from 'pages/custom/EmistatusPage';
import EmicollectionstatusPage from 'pages/custom/EmicollectionstatusPage';
import VemicalculatorPage from 'pages/custom/VemicalculatorPage';
import CashflowPage from 'pages/custom/CashflowPage';
import OverduechargepostingPage from 'pages/custom/OverduechargepostingPage';
import UploadexcelPage from 'pages/custom/UploadexcelPage';
import BmPage from 'pages/home/BmPage';
import ReschedulePage from 'pages/custom/ReschedulePage';
import AccountPages from 'pages/account';
import HomePage from './pages/home/HomePage';
import IndexPages from './pages/index';
import ErrorPages from './pages/errors';
import 'primereact/resources/primereact.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import 'assets/styles/layout.scss';
import "./utils/fixLeafletIcons";

const App = () => {
	const auth = useAuth();
	function DefaultPage(){
		if(!auth.isLoggedIn){
			return <IndexPage />
		}
		return <Navigate to="/home" replace />;
	}
	function UserRoleHomePage(){
		const userRole = (auth.userRole || '').toLowerCase();
		switch(userRole){
			case 'collection':
				return <CollectionPage />
			case 'bm':
				return <BmPage />
			default:
				return <HomePage />;
		}
	}
	return (
		<Routes>
			<Route exact element={<AuthRoutes />}>
			<Route element={<MainLayout />}>
				<Route path="/home" element={<UserRoleHomePage />} />
				

				{/* accountgroup pages routes */}
				<Route path="/accountgroup" element={<AccountgroupList />} />
				<Route path="/accountgroup/:fieldName/:fieldValue" element={<AccountgroupList />} />
				<Route path="/accountgroup/index/:fieldName/:fieldValue" element={<AccountgroupList />} />
				<Route path="/accountgroup/view/:pageid" element={<AccountgroupView />} />
				<Route path="/accountgroup/add" element={<AccountgroupAdd />} />
				<Route path="/accountgroup/edit/:pageid" element={<AccountgroupEdit />} />

				{/* accountmaster pages routes */}
				<Route path="/accountmaster" element={<AccountmasterList />} />
				<Route path="/accountmaster/:fieldName/:fieldValue" element={<AccountmasterList />} />
				<Route path="/accountmaster/index/:fieldName/:fieldValue" element={<AccountmasterList />} />
				<Route path="/accountmaster/view/:pageid" element={<AccountmasterView />} />
				<Route path="/accountmaster/add" element={<AccountmasterAdd />} />
				<Route path="/accountmaster/edit/:pageid" element={<AccountmasterEdit />} />

				{/* accountpbmaster pages routes */}
				<Route path="/accountpbmaster" element={<AccountpbmasterList />} />
				<Route path="/accountpbmaster/:fieldName/:fieldValue" element={<AccountpbmasterList />} />
				<Route path="/accountpbmaster/index/:fieldName/:fieldValue" element={<AccountpbmasterList />} />
				<Route path="/accountpbmaster/view/:pageid" element={<AccountpbmasterView />} />
				<Route path="/accountpbmaster/add" element={<AccountpbmasterAdd />} />
				<Route path="/accountpbmaster/edit/:pageid" element={<AccountpbmasterEdit />} />

				{/* agentmaster pages routes */}
				<Route path="/agentmaster" element={<AgentmasterList />} />
				<Route path="/agentmaster/:fieldName/:fieldValue" element={<AgentmasterList />} />
				<Route path="/agentmaster/index/:fieldName/:fieldValue" element={<AgentmasterList />} />
				<Route path="/agentmaster/view/:pageid" element={<AgentmasterView />} />
				<Route path="/agentmaster/add" element={<AgentmasterAdd />} />
				<Route path="/agentmaster/edit/:pageid" element={<AgentmasterEdit />} />

				{/* agenttransaction pages routes */}
				<Route path="/agenttransaction" element={<AgenttransactionList />} />
				<Route path="/agenttransaction/:fieldName/:fieldValue" element={<AgenttransactionList />} />
				<Route path="/agenttransaction/index/:fieldName/:fieldValue" element={<AgenttransactionList />} />
				<Route path="/agenttransaction/view/:pageid" element={<AgenttransactionView />} />
				<Route path="/agenttransaction/add" element={<AgenttransactionAdd />} />
				<Route path="/agenttransaction/edit/:pageid" element={<AgenttransactionEdit />} />

				{/* alertvw pages routes */}
				<Route path="/alertvw" element={<AlertvwList />} />
				<Route path="/alertvw/:fieldName/:fieldValue" element={<AlertvwList />} />
				<Route path="/alertvw/index/:fieldName/:fieldValue" element={<AlertvwList />} />
				<Route path="/alertvw/view/:pageid" element={<AlertvwView />} />

				{/* allsummaryvw pages routes */}
				<Route path="/allsummaryvw" element={<AllsummaryvwList />} />
				<Route path="/allsummaryvw/:fieldName/:fieldValue" element={<AllsummaryvwList />} />
				<Route path="/allsummaryvw/index/:fieldName/:fieldValue" element={<AllsummaryvwList />} />

				{/* applicationmaster pages routes */}
				<Route path="/applicationmaster" element={<ApplicationmasterList />} />
				<Route path="/applicationmaster/:fieldName/:fieldValue" element={<ApplicationmasterList />} />
				<Route path="/applicationmaster/index/:fieldName/:fieldValue" element={<ApplicationmasterList />} />
				<Route path="/applicationmaster/view/:pageid" element={<ApplicationmasterView />} />
				<Route path="/applicationmaster/add" element={<ApplicationmasterAdd />} />
				<Route path="/applicationmaster/edit/:pageid" element={<ApplicationmasterEdit />} />
				<Route path="/applicationmaster/appstep2/:pageid" element={<ApplicationmasterAppstep2 />} />
				<Route path="/applicationmaster/appstep1" element={<ApplicationmasterAppstep1 />} />

				{/* areamaster pages routes */}
				<Route path="/areamaster" element={<AreamasterList />} />
				<Route path="/areamaster/:fieldName/:fieldValue" element={<AreamasterList />} />
				<Route path="/areamaster/index/:fieldName/:fieldValue" element={<AreamasterList />} />
				<Route path="/areamaster/view/:pageid" element={<AreamasterView />} />
				<Route path="/areamaster/add" element={<AreamasterAdd />} />
				<Route path="/areamaster/edit/:pageid" element={<AreamasterEdit />} />

				{/* assetmaster pages routes */}
				<Route path="/assetmaster" element={<AssetmasterList />} />
				<Route path="/assetmaster/:fieldName/:fieldValue" element={<AssetmasterList />} />
				<Route path="/assetmaster/index/:fieldName/:fieldValue" element={<AssetmasterList />} />
				<Route path="/assetmaster/view/:pageid" element={<AssetmasterView />} />
				<Route path="/assetmaster/add" element={<AssetmasterAdd />} />
				<Route path="/assetmaster/edit/:pageid" element={<AssetmasterEdit />} />

				{/* attendance pages routes */}
				<Route path="/attendance" element={<AttendanceList />} />
				<Route path="/attendance/:fieldName/:fieldValue" element={<AttendanceList />} />
				<Route path="/attendance/index/:fieldName/:fieldValue" element={<AttendanceList />} />
				<Route path="/attendance/view/:pageid" element={<AttendanceView />} />
				<Route path="/attendance/add" element={<AttendanceAdd />} />
				<Route path="/attendance/edit/:pageid" element={<AttendanceEdit />} />

				{/* balancevw pages routes */}
				<Route path="/balancevw" element={<BalancevwList />} />
				<Route path="/balancevw/:fieldName/:fieldValue" element={<BalancevwList />} />
				<Route path="/balancevw/index/:fieldName/:fieldValue" element={<BalancevwList />} />

				{/* bank pages routes */}
				<Route path="/bank" element={<BankList />} />
				<Route path="/bank/:fieldName/:fieldValue" element={<BankList />} />
				<Route path="/bank/index/:fieldName/:fieldValue" element={<BankList />} />
				<Route path="/bank/view/:pageid" element={<BankView />} />
				<Route path="/bank/add" element={<BankAdd />} />
				<Route path="/bank/edit/:pageid" element={<BankEdit />} />

				{/* batches pages routes */}
				<Route path="/batches" element={<BatchesList />} />
				<Route path="/batches/:fieldName/:fieldValue" element={<BatchesList />} />
				<Route path="/batches/index/:fieldName/:fieldValue" element={<BatchesList />} />
				<Route path="/batches/view/:pageid" element={<BatchesView />} />
				<Route path="/batches/add" element={<BatchesAdd />} />
				<Route path="/batches/edit/:pageid" element={<BatchesEdit />} />

				{/* bbpsbillervw pages routes */}
				<Route path="/bbpsbillervw" element={<BbpsbillervwList />} />
				<Route path="/bbpsbillervw/:fieldName/:fieldValue" element={<BbpsbillervwList />} />
				<Route path="/bbpsbillervw/index/:fieldName/:fieldValue" element={<BbpsbillervwList />} />

				{/* branchmaster pages routes */}
				<Route path="/branchmaster" element={<BranchmasterList />} />
				<Route path="/branchmaster/:fieldName/:fieldValue" element={<BranchmasterList />} />
				<Route path="/branchmaster/index/:fieldName/:fieldValue" element={<BranchmasterList />} />
				<Route path="/branchmaster/view/:pageid" element={<BranchmasterView />} />
				<Route path="/branchmaster/add" element={<BranchmasterAdd />} />
				<Route path="/branchmaster/edit/:pageid" element={<BranchmasterEdit />} />

				{/* branchtransaction pages routes */}
				<Route path="/branchtransaction" element={<BranchtransactionList />} />
				<Route path="/branchtransaction/:fieldName/:fieldValue" element={<BranchtransactionList />} />
				<Route path="/branchtransaction/index/:fieldName/:fieldValue" element={<BranchtransactionList />} />
				<Route path="/branchtransaction/view/:pageid" element={<BranchtransactionView />} />
				<Route path="/branchtransaction/add" element={<BranchtransactionAdd />} />
				<Route path="/branchtransaction/edit/:pageid" element={<BranchtransactionEdit />} />

				{/* carryforwardcalculationvw pages routes */}
				<Route path="/carryforwardcalculationvw" element={<CarryforwardcalculationvwList />} />
				<Route path="/carryforwardcalculationvw/:fieldName/:fieldValue" element={<CarryforwardcalculationvwList />} />
				<Route path="/carryforwardcalculationvw/index/:fieldName/:fieldValue" element={<CarryforwardcalculationvwList />} />

				{/* codesetting pages routes */}
				<Route path="/codesetting" element={<CodesettingList />} />
				<Route path="/codesetting/:fieldName/:fieldValue" element={<CodesettingList />} />
				<Route path="/codesetting/index/:fieldName/:fieldValue" element={<CodesettingList />} />
				<Route path="/codesetting/view/:pageid" element={<CodesettingView />} />
				<Route path="/codesetting/add" element={<CodesettingAdd />} />
				<Route path="/codesetting/edit/:pageid" element={<CodesettingEdit />} />

				{/* collectiontypevw pages routes */}
				<Route path="/collectiontypevw" element={<CollectiontypevwList />} />
				<Route path="/collectiontypevw/:fieldName/:fieldValue" element={<CollectiontypevwList />} />
				<Route path="/collectiontypevw/index/:fieldName/:fieldValue" element={<CollectiontypevwList />} />

				{/* creditreport pages routes */}
				<Route path="/creditreport" element={<CreditreportList />} />
				<Route path="/creditreport/:fieldName/:fieldValue" element={<CreditreportList />} />
				<Route path="/creditreport/index/:fieldName/:fieldValue" element={<CreditreportList />} />
				<Route path="/creditreport/view/:pageid" element={<CreditreportView />} />
				<Route path="/creditreport/add" element={<CreditreportAdd />} />
				<Route path="/creditreport/edit/:pageid" element={<CreditreportEdit />} />

				{/* creditreportraw pages routes */}
				<Route path="/creditreportraw" element={<CreditreportrawList />} />
				<Route path="/creditreportraw/:fieldName/:fieldValue" element={<CreditreportrawList />} />
				<Route path="/creditreportraw/index/:fieldName/:fieldValue" element={<CreditreportrawList />} />
				<Route path="/creditreportraw/view/:pageid" element={<CreditreportrawView />} />
				<Route path="/creditreportraw/add" element={<CreditreportrawAdd />} />
				<Route path="/creditreportraw/edit/:pageid" element={<CreditreportrawEdit />} />

				{/* creditreportsummary pages routes */}
				<Route path="/creditreportsummary" element={<CreditreportsummaryList />} />
				<Route path="/creditreportsummary/:fieldName/:fieldValue" element={<CreditreportsummaryList />} />
				<Route path="/creditreportsummary/index/:fieldName/:fieldValue" element={<CreditreportsummaryList />} />
				<Route path="/creditreportsummary/view/:pageid" element={<CreditreportsummaryView />} />
				<Route path="/creditreportsummary/add" element={<CreditreportsummaryAdd />} />
				<Route path="/creditreportsummary/edit/:pageid" element={<CreditreportsummaryEdit />} />

				{/* creditrequest pages routes */}
				<Route path="/creditrequest" element={<CreditrequestList />} />
				<Route path="/creditrequest/:fieldName/:fieldValue" element={<CreditrequestList />} />
				<Route path="/creditrequest/index/:fieldName/:fieldValue" element={<CreditrequestList />} />
				<Route path="/creditrequest/view/:pageid" element={<CreditrequestView />} />
				<Route path="/creditrequest/add" element={<CreditrequestAdd />} />
				<Route path="/creditrequest/edit/:pageid" element={<CreditrequestEdit />} />

				{/* credittbl pages routes */}
				<Route path="/credittbl" element={<CredittblList />} />
				<Route path="/credittbl/:fieldName/:fieldValue" element={<CredittblList />} />
				<Route path="/credittbl/index/:fieldName/:fieldValue" element={<CredittblList />} />
				<Route path="/credittbl/view/:pageid" element={<CredittblView />} />
				<Route path="/credittbl/add" element={<CredittblAdd />} />
				<Route path="/credittbl/edit/:pageid" element={<CredittblEdit />} />

				{/* custdata pages routes */}
				<Route path="/custdata" element={<CustdataList />} />
				<Route path="/custdata/:fieldName/:fieldValue" element={<CustdataList />} />
				<Route path="/custdata/index/:fieldName/:fieldValue" element={<CustdataList />} />
				<Route path="/custdata/view/:pageid" element={<CustdataView />} />
				<Route path="/custdata/add" element={<CustdataAdd />} />
				<Route path="/custdata/edit/:pageid" element={<CustdataEdit />} />

				{/* demandlistvw pages routes */}
				<Route path="/demandlistvw" element={<DemandlistvwList />} />
				<Route path="/demandlistvw/:fieldName/:fieldValue" element={<DemandlistvwList />} />
				<Route path="/demandlistvw/index/:fieldName/:fieldValue" element={<DemandlistvwList />} />
				<Route path="/demandlistvw/branch_list" element={<DemandlistvwBranchlist />} />
				<Route path="/demandlistvw/branch_list/:fieldName/:fieldValue" element={<DemandlistvwBranchlist />} />

				{/* designationmaster pages routes */}
				<Route path="/designationmaster" element={<DesignationmasterList />} />
				<Route path="/designationmaster/:fieldName/:fieldValue" element={<DesignationmasterList />} />
				<Route path="/designationmaster/index/:fieldName/:fieldValue" element={<DesignationmasterList />} />
				<Route path="/designationmaster/view/:pageid" element={<DesignationmasterView />} />
				<Route path="/designationmaster/add" element={<DesignationmasterAdd />} />
				<Route path="/designationmaster/edit/:pageid" element={<DesignationmasterEdit />} />

				{/* district pages routes */}
				<Route path="/district" element={<DistrictList />} />
				<Route path="/district/:fieldName/:fieldValue" element={<DistrictList />} />
				<Route path="/district/index/:fieldName/:fieldValue" element={<DistrictList />} />
				<Route path="/district/view/:pageid" element={<DistrictView />} />
				<Route path="/district/add" element={<DistrictAdd />} />
				<Route path="/district/edit/:pageid" element={<DistrictEdit />} />

				{/* documentmaster pages routes */}
				<Route path="/documentmaster" element={<DocumentmasterList />} />
				<Route path="/documentmaster/:fieldName/:fieldValue" element={<DocumentmasterList />} />
				<Route path="/documentmaster/index/:fieldName/:fieldValue" element={<DocumentmasterList />} />
				<Route path="/documentmaster/view/:pageid" element={<DocumentmasterView />} />
				<Route path="/documentmaster/add" element={<DocumentmasterAdd />} />
				<Route path="/documentmaster/edit/:pageid" element={<DocumentmasterEdit />} />

				{/* employeeleavehistoryvw pages routes */}
				<Route path="/employeeleavehistoryvw" element={<EmployeeleavehistoryvwList />} />
				<Route path="/employeeleavehistoryvw/:fieldName/:fieldValue" element={<EmployeeleavehistoryvwList />} />
				<Route path="/employeeleavehistoryvw/index/:fieldName/:fieldValue" element={<EmployeeleavehistoryvwList />} />

				{/* empmaster pages routes */}
				<Route path="/empmaster" element={<EmpmasterList />} />
				<Route path="/empmaster/:fieldName/:fieldValue" element={<EmpmasterList />} />
				<Route path="/empmaster/index/:fieldName/:fieldValue" element={<EmpmasterList />} />
				<Route path="/empmaster/view/:pageid" element={<EmpmasterView />} />
				<Route path="/empmaster/add" element={<EmpmasterAdd />} />
				<Route path="/empmaster/edit/:pageid" element={<EmpmasterEdit />} />

				{/* equistates pages routes */}
				<Route path="/equistates" element={<EquistatesList />} />
				<Route path="/equistates/:fieldName/:fieldValue" element={<EquistatesList />} />
				<Route path="/equistates/index/:fieldName/:fieldValue" element={<EquistatesList />} />
				<Route path="/equistates/view/:pageid" element={<EquistatesView />} />
				<Route path="/equistates/add" element={<EquistatesAdd />} />
				<Route path="/equistates/edit/:pageid" element={<EquistatesEdit />} />

				{/* fixedaccount pages routes */}
				<Route path="/fixedaccount" element={<FixedaccountList />} />
				<Route path="/fixedaccount/:fieldName/:fieldValue" element={<FixedaccountList />} />
				<Route path="/fixedaccount/index/:fieldName/:fieldValue" element={<FixedaccountList />} />
				<Route path="/fixedaccount/view/:pageid" element={<FixedaccountView />} />
				<Route path="/fixedaccount/add" element={<FixedaccountAdd />} />
				<Route path="/fixedaccount/edit/:pageid" element={<FixedaccountEdit />} />

				{/* getemployeeleavebalancevw pages routes */}
				<Route path="/getemployeeleavebalancevw" element={<GetemployeeleavebalancevwList />} />
				<Route path="/getemployeeleavebalancevw/:fieldName/:fieldValue" element={<GetemployeeleavebalancevwList />} />
				<Route path="/getemployeeleavebalancevw/index/:fieldName/:fieldValue" element={<GetemployeeleavebalancevwList />} />

				{/* grouploanamort pages routes */}
				<Route path="/grouploanamort" element={<GrouploanamortList />} />
				<Route path="/grouploanamort/:fieldName/:fieldValue" element={<GrouploanamortList />} />
				<Route path="/grouploanamort/index/:fieldName/:fieldValue" element={<GrouploanamortList />} />
				<Route path="/grouploanamort/view/:pageid" element={<GrouploanamortView />} />
				<Route path="/grouploanamort/add" element={<GrouploanamortAdd />} />
				<Route path="/grouploanamort/edit/:pageid" element={<GrouploanamortEdit />} />

				{/* grouploancontract pages routes */}
				<Route path="/grouploancontract" element={<GrouploancontractList />} />
				<Route path="/grouploancontract/:fieldName/:fieldValue" element={<GrouploancontractList />} />
				<Route path="/grouploancontract/index/:fieldName/:fieldValue" element={<GrouploancontractList />} />
				<Route path="/grouploancontract/view/:pageid" element={<GrouploancontractView />} />
				<Route path="/grouploancontract/add" element={<GrouploancontractAdd />} />
				<Route path="/grouploancontract/edit/:pageid" element={<GrouploancontractEdit />} />
				<Route path="/grouploancontract/branch_list" element={<GrouploancontractBranchlist />} />
				<Route path="/grouploancontract/branch_list/:fieldName/:fieldValue" element={<GrouploancontractBranchlist />} />

				{/* grouploantransaction pages routes */}
				<Route path="/grouploantransaction" element={<GrouploantransactionList />} />
				<Route path="/grouploantransaction/:fieldName/:fieldValue" element={<GrouploantransactionList />} />
				<Route path="/grouploantransaction/index/:fieldName/:fieldValue" element={<GrouploantransactionList />} />
				<Route path="/grouploantransaction/view/:pageid" element={<GrouploantransactionView />} />
				<Route path="/grouploantransaction/add" element={<GrouploantransactionAdd />} />
				<Route path="/grouploantransaction/edit/:pageid" element={<GrouploantransactionEdit />} />

				{/* hymarkfooter pages routes */}
				<Route path="/hymarkfooter" element={<HymarkfooterList />} />
				<Route path="/hymarkfooter/:fieldName/:fieldValue" element={<HymarkfooterList />} />
				<Route path="/hymarkfooter/index/:fieldName/:fieldValue" element={<HymarkfooterList />} />

				{/* hymarkheader pages routes */}
				<Route path="/hymarkheader" element={<HymarkheaderList />} />
				<Route path="/hymarkheader/:fieldName/:fieldValue" element={<HymarkheaderList />} />
				<Route path="/hymarkheader/index/:fieldName/:fieldValue" element={<HymarkheaderList />} />

				{/* journalmaster pages routes */}
				<Route path="/journalmaster" element={<JournalmasterList />} />
				<Route path="/journalmaster/:fieldName/:fieldValue" element={<JournalmasterList />} />
				<Route path="/journalmaster/index/:fieldName/:fieldValue" element={<JournalmasterList />} />
				<Route path="/journalmaster/view/:pageid" element={<JournalmasterView />} />
				<Route path="/journalmaster/add" element={<JournalmasterAdd />} />
				<Route path="/journalmaster/edit/:pageid" element={<JournalmasterEdit />} />

				{/* journals pages routes */}
				<Route path="/journals" element={<JournalsList />} />
				<Route path="/journals/:fieldName/:fieldValue" element={<JournalsList />} />
				<Route path="/journals/index/:fieldName/:fieldValue" element={<JournalsList />} />
				<Route path="/journals/view/:pageid" element={<JournalsView />} />
				<Route path="/journals/add" element={<JournalsAdd />} />
				<Route path="/journals/edit/:pageid" element={<JournalsEdit />} />

				{/* leavecalendarreportvw pages routes */}
				<Route path="/leavecalendarreportvw" element={<LeavecalendarreportvwList />} />
				<Route path="/leavecalendarreportvw/:fieldName/:fieldValue" element={<LeavecalendarreportvwList />} />
				<Route path="/leavecalendarreportvw/index/:fieldName/:fieldValue" element={<LeavecalendarreportvwList />} />

				{/* leavedetails pages routes */}
				<Route path="/leavedetails" element={<LeavedetailsList />} />
				<Route path="/leavedetails/:fieldName/:fieldValue" element={<LeavedetailsList />} />
				<Route path="/leavedetails/index/:fieldName/:fieldValue" element={<LeavedetailsList />} />
				<Route path="/leavedetails/view/:pageid" element={<LeavedetailsView />} />
				<Route path="/leavedetails/add" element={<LeavedetailsAdd />} />
				<Route path="/leavedetails/edit/:pageid" element={<LeavedetailsEdit />} />

				{/* leavemaster pages routes */}
				<Route path="/leavemaster" element={<LeavemasterList />} />
				<Route path="/leavemaster/:fieldName/:fieldValue" element={<LeavemasterList />} />
				<Route path="/leavemaster/index/:fieldName/:fieldValue" element={<LeavemasterList />} />
				<Route path="/leavemaster/view/:pageid" element={<LeavemasterView />} />
				<Route path="/leavemaster/add" element={<LeavemasterAdd />} />
				<Route path="/leavemaster/edit/:pageid" element={<LeavemasterEdit />} />

				{/* leaveperioddetails pages routes */}
				<Route path="/leaveperioddetails" element={<LeaveperioddetailsList />} />
				<Route path="/leaveperioddetails/:fieldName/:fieldValue" element={<LeaveperioddetailsList />} />
				<Route path="/leaveperioddetails/index/:fieldName/:fieldValue" element={<LeaveperioddetailsList />} />
				<Route path="/leaveperioddetails/view/:pageid" element={<LeaveperioddetailsView />} />
				<Route path="/leaveperioddetails/add" element={<LeaveperioddetailsAdd />} />
				<Route path="/leaveperioddetails/edit/:pageid" element={<LeaveperioddetailsEdit />} />

				{/* leavetypemaster pages routes */}
				<Route path="/leavetypemaster" element={<LeavetypemasterList />} />
				<Route path="/leavetypemaster/:fieldName/:fieldValue" element={<LeavetypemasterList />} />
				<Route path="/leavetypemaster/index/:fieldName/:fieldValue" element={<LeavetypemasterList />} />
				<Route path="/leavetypemaster/view/:pageid" element={<LeavetypemasterView />} />
				<Route path="/leavetypemaster/add" element={<LeavetypemasterAdd />} />
				<Route path="/leavetypemaster/edit/:pageid" element={<LeavetypemasterEdit />} />

				{/* leaveutilizationsummaryvw pages routes */}
				<Route path="/leaveutilizationsummaryvw" element={<LeaveutilizationsummaryvwList />} />
				<Route path="/leaveutilizationsummaryvw/:fieldName/:fieldValue" element={<LeaveutilizationsummaryvwList />} />
				<Route path="/leaveutilizationsummaryvw/index/:fieldName/:fieldValue" element={<LeaveutilizationsummaryvwList />} />

				{/* loangroup pages routes */}
				<Route path="/loangroup" element={<LoangroupList />} />
				<Route path="/loangroup/:fieldName/:fieldValue" element={<LoangroupList />} />
				<Route path="/loangroup/index/:fieldName/:fieldValue" element={<LoangroupList />} />
				<Route path="/loangroup/view/:pageid" element={<LoangroupView />} />
				<Route path="/loangroup/add" element={<LoangroupAdd />} />
				<Route path="/loangroup/edit/:pageid" element={<LoangroupEdit />} />

				{/* loanguarantor pages routes */}
				<Route path="/loanguarantor" element={<LoanguarantorList />} />
				<Route path="/loanguarantor/:fieldName/:fieldValue" element={<LoanguarantorList />} />
				<Route path="/loanguarantor/index/:fieldName/:fieldValue" element={<LoanguarantorList />} />
				<Route path="/loanguarantor/view/:pageid" element={<LoanguarantorView />} />
				<Route path="/loanguarantor/add" element={<LoanguarantorAdd />} />
				<Route path="/loanguarantor/edit/:pageid" element={<LoanguarantorEdit />} />

				{/* loanproduct pages routes */}
				<Route path="/loanproduct" element={<LoanproductList />} />
				<Route path="/loanproduct/:fieldName/:fieldValue" element={<LoanproductList />} />
				<Route path="/loanproduct/index/:fieldName/:fieldValue" element={<LoanproductList />} />
				<Route path="/loanproduct/view/:pageid" element={<LoanproductView />} />
				<Route path="/loanproduct/add" element={<LoanproductAdd />} />
				<Route path="/loanproduct/edit/:pageid" element={<LoanproductEdit />} />

				{/* loanpurpose pages routes */}
				<Route path="/loanpurpose" element={<LoanpurposeList />} />
				<Route path="/loanpurpose/:fieldName/:fieldValue" element={<LoanpurposeList />} />
				<Route path="/loanpurpose/index/:fieldName/:fieldValue" element={<LoanpurposeList />} />
				<Route path="/loanpurpose/view/:pageid" element={<LoanpurposeView />} />
				<Route path="/loanpurpose/add" element={<LoanpurposeAdd />} />
				<Route path="/loanpurpose/edit/:pageid" element={<LoanpurposeEdit />} />

				{/* mandatedebitvw pages routes */}
				<Route path="/mandatedebitvw" element={<MandatedebitvwList />} />
				<Route path="/mandatedebitvw/:fieldName/:fieldValue" element={<MandatedebitvwList />} />
				<Route path="/mandatedebitvw/index/:fieldName/:fieldValue" element={<MandatedebitvwList />} />
				<Route path="/mandatedebitvw/view/:pageid" element={<MandatedebitvwView />} />

				{/* mandateworld pages routes */}
				<Route path="/mandateworld" element={<MandateworldList />} />
				<Route path="/mandateworld/:fieldName/:fieldValue" element={<MandateworldList />} />
				<Route path="/mandateworld/index/:fieldName/:fieldValue" element={<MandateworldList />} />
				<Route path="/mandateworld/view/:pageid" element={<MandateworldView />} />
				<Route path="/mandateworld/add" element={<MandateworldAdd />} />
				<Route path="/mandateworld/edit/:pageid" element={<MandateworldEdit />} />

				{/* meetingcenter pages routes */}
				<Route path="/meetingcenter" element={<MeetingcenterList />} />
				<Route path="/meetingcenter/:fieldName/:fieldValue" element={<MeetingcenterList />} />
				<Route path="/meetingcenter/index/:fieldName/:fieldValue" element={<MeetingcenterList />} />
				<Route path="/meetingcenter/view/:pageid" element={<MeetingcenterView />} />
				<Route path="/meetingcenter/add" element={<MeetingcenterAdd />} />
				<Route path="/meetingcenter/edit/:pageid" element={<MeetingcenterEdit />} />

				{/* membermaster pages routes */}
				<Route path="/membermaster" element={<MembermasterList />} />
				<Route path="/membermaster/:fieldName/:fieldValue" element={<MembermasterList />} />
				<Route path="/membermaster/index/:fieldName/:fieldValue" element={<MembermasterList />} />
				<Route path="/membermaster/view/:pageid" element={<MembermasterView />} />
				<Route path="/membermaster/add" element={<MembermasterAdd />} />
				<Route path="/membermaster/edit/:pageid" element={<MembermasterEdit />} />

				{/* negativemaster pages routes */}
				<Route path="/negativemaster" element={<NegativemasterList />} />
				<Route path="/negativemaster/:fieldName/:fieldValue" element={<NegativemasterList />} />
				<Route path="/negativemaster/index/:fieldName/:fieldValue" element={<NegativemasterList />} />
				<Route path="/negativemaster/view/:pageid" element={<NegativemasterView />} />
				<Route path="/negativemaster/add" element={<NegativemasterAdd />} />
				<Route path="/negativemaster/edit/:pageid" element={<NegativemasterEdit />} />

				{/* news pages routes */}
				<Route path="/news" element={<NewsList />} />
				<Route path="/news/:fieldName/:fieldValue" element={<NewsList />} />
				<Route path="/news/index/:fieldName/:fieldValue" element={<NewsList />} />
				<Route path="/news/view/:pageid" element={<NewsView />} />
				<Route path="/news/add" element={<NewsAdd />} />
				<Route path="/news/edit/:pageid" element={<NewsEdit />} />

				{/* notifymaster pages routes */}
				<Route path="/notifymaster" element={<NotifymasterList />} />
				<Route path="/notifymaster/:fieldName/:fieldValue" element={<NotifymasterList />} />
				<Route path="/notifymaster/index/:fieldName/:fieldValue" element={<NotifymasterList />} />
				<Route path="/notifymaster/view/:pageid" element={<NotifymasterView />} />
				<Route path="/notifymaster/add" element={<NotifymasterAdd />} />
				<Route path="/notifymaster/edit/:pageid" element={<NotifymasterEdit />} />

				{/* notreceivedvw pages routes */}
				<Route path="/notreceivedvw" element={<NotreceivedvwList />} />
				<Route path="/notreceivedvw/:fieldName/:fieldValue" element={<NotreceivedvwList />} />
				<Route path="/notreceivedvw/index/:fieldName/:fieldValue" element={<NotreceivedvwList />} />

				{/* overduecharges pages routes */}
				<Route path="/overduecharges" element={<OverduechargesList />} />
				<Route path="/overduecharges/:fieldName/:fieldValue" element={<OverduechargesList />} />
				<Route path="/overduecharges/index/:fieldName/:fieldValue" element={<OverduechargesList />} />
				<Route path="/overduecharges/view/:pageid" element={<OverduechargesView />} />
				<Route path="/overduecharges/add" element={<OverduechargesAdd />} />
				<Route path="/overduecharges/edit/:pageid" element={<OverduechargesEdit />} />

				{/* paydetails pages routes */}
				<Route path="/paydetails" element={<PaydetailsList />} />
				<Route path="/paydetails/:fieldName/:fieldValue" element={<PaydetailsList />} />
				<Route path="/paydetails/index/:fieldName/:fieldValue" element={<PaydetailsList />} />
				<Route path="/paydetails/view/:pageid" element={<PaydetailsView />} />
				<Route path="/paydetails/add" element={<PaydetailsAdd />} />
				<Route path="/paydetails/edit/:pageid" element={<PaydetailsEdit />} />

				{/* paygroupvw pages routes */}
				<Route path="/paygroupvw" element={<PaygroupvwList />} />
				<Route path="/paygroupvw/:fieldName/:fieldValue" element={<PaygroupvwList />} />
				<Route path="/paygroupvw/index/:fieldName/:fieldValue" element={<PaygroupvwList />} />

				{/* paymaster pages routes */}
				<Route path="/paymaster" element={<PaymasterList />} />
				<Route path="/paymaster/:fieldName/:fieldValue" element={<PaymasterList />} />
				<Route path="/paymaster/index/:fieldName/:fieldValue" element={<PaymasterList />} />
				<Route path="/paymaster/view/:pageid" element={<PaymasterView />} />
				<Route path="/paymaster/add" element={<PaymasterAdd />} />
				<Route path="/paymaster/edit/:pageid" element={<PaymasterEdit />} />

				{/* paytranvw pages routes */}
				<Route path="/paytranvw" element={<PaytranvwList />} />
				<Route path="/paytranvw/:fieldName/:fieldValue" element={<PaytranvwList />} />
				<Route path="/paytranvw/index/:fieldName/:fieldValue" element={<PaytranvwList />} />

				{/* permissions pages routes */}
				<Route path="/permissions" element={<PermissionsList />} />
				<Route path="/permissions/:fieldName/:fieldValue" element={<PermissionsList />} />
				<Route path="/permissions/index/:fieldName/:fieldValue" element={<PermissionsList />} />
				<Route path="/permissions/view/:pageid" element={<PermissionsView />} />
				<Route path="/permissions/add" element={<PermissionsAdd />} />
				<Route path="/permissions/edit/:pageid" element={<PermissionsEdit />} />

				{/* policestation pages routes */}
				<Route path="/policestation" element={<PolicestationList />} />
				<Route path="/policestation/:fieldName/:fieldValue" element={<PolicestationList />} />
				<Route path="/policestation/index/:fieldName/:fieldValue" element={<PolicestationList />} />
				<Route path="/policestation/view/:pageid" element={<PolicestationView />} />
				<Route path="/policestation/add" element={<PolicestationAdd />} />
				<Route path="/policestation/edit/:pageid" element={<PolicestationEdit />} />

				{/* preinterestdetl pages routes */}
				<Route path="/preinterestdetl" element={<PreinterestdetlList />} />
				<Route path="/preinterestdetl/:fieldName/:fieldValue" element={<PreinterestdetlList />} />
				<Route path="/preinterestdetl/index/:fieldName/:fieldValue" element={<PreinterestdetlList />} />
				<Route path="/preinterestdetl/view/:pageid" element={<PreinterestdetlView />} />
				<Route path="/preinterestdetl/add" element={<PreinterestdetlAdd />} />
				<Route path="/preinterestdetl/edit/:pageid" element={<PreinterestdetlEdit />} />

				{/* rankmaster pages routes */}
				<Route path="/rankmaster" element={<RankmasterList />} />
				<Route path="/rankmaster/:fieldName/:fieldValue" element={<RankmasterList />} />
				<Route path="/rankmaster/index/:fieldName/:fieldValue" element={<RankmasterList />} />
				<Route path="/rankmaster/view/:pageid" element={<RankmasterView />} />
				<Route path="/rankmaster/add" element={<RankmasterAdd />} />
				<Route path="/rankmaster/edit/:pageid" element={<RankmasterEdit />} />

				{/* receivedvw pages routes */}
				<Route path="/receivedvw" element={<ReceivedvwList />} />
				<Route path="/receivedvw/:fieldName/:fieldValue" element={<ReceivedvwList />} />
				<Route path="/receivedvw/index/:fieldName/:fieldValue" element={<ReceivedvwList />} />

				{/* relationmaster pages routes */}
				<Route path="/relationmaster" element={<RelationmasterList />} />
				<Route path="/relationmaster/:fieldName/:fieldValue" element={<RelationmasterList />} />
				<Route path="/relationmaster/index/:fieldName/:fieldValue" element={<RelationmasterList />} />
				<Route path="/relationmaster/view/:pageid" element={<RelationmasterView />} />
				<Route path="/relationmaster/add" element={<RelationmasterAdd />} />
				<Route path="/relationmaster/edit/:pageid" element={<RelationmasterEdit />} />

				{/* remoteipmaster pages routes */}
				<Route path="/remoteipmaster" element={<RemoteipmasterList />} />
				<Route path="/remoteipmaster/:fieldName/:fieldValue" element={<RemoteipmasterList />} />
				<Route path="/remoteipmaster/index/:fieldName/:fieldValue" element={<RemoteipmasterList />} />
				<Route path="/remoteipmaster/view/:pageid" element={<RemoteipmasterView />} />
				<Route path="/remoteipmaster/add" element={<RemoteipmasterAdd />} />
				<Route path="/remoteipmaster/edit/:pageid" element={<RemoteipmasterEdit />} />

				{/* roles pages routes */}
				<Route path="/roles" element={<RolesList />} />
				<Route path="/roles/:fieldName/:fieldValue" element={<RolesList />} />
				<Route path="/roles/index/:fieldName/:fieldValue" element={<RolesList />} />
				<Route path="/roles/view/:pageid" element={<RolesView />} />
				<Route path="/roles/add" element={<RolesAdd />} />
				<Route path="/roles/edit/:pageid" element={<RolesEdit />} />

				{/* salarysheet pages routes */}
				<Route path="/salarysheet" element={<SalarysheetList />} />
				<Route path="/salarysheet/:fieldName/:fieldValue" element={<SalarysheetList />} />
				<Route path="/salarysheet/index/:fieldName/:fieldValue" element={<SalarysheetList />} />
				<Route path="/salarysheet/view/:pageid" element={<SalarysheetView />} />
				<Route path="/salarysheet/add" element={<SalarysheetAdd />} />
				<Route path="/salarysheet/edit/:pageid" element={<SalarysheetEdit />} />

				{/* scheduleexpiredvw pages routes */}
				<Route path="/scheduleexpiredvw" element={<ScheduleexpiredvwList />} />
				<Route path="/scheduleexpiredvw/:fieldName/:fieldValue" element={<ScheduleexpiredvwList />} />
				<Route path="/scheduleexpiredvw/index/:fieldName/:fieldValue" element={<ScheduleexpiredvwList />} />

				{/* settingmaster pages routes */}
				<Route path="/settingmaster" element={<SettingmasterList />} />
				<Route path="/settingmaster/:fieldName/:fieldValue" element={<SettingmasterList />} />
				<Route path="/settingmaster/index/:fieldName/:fieldValue" element={<SettingmasterList />} />
				<Route path="/settingmaster/view/:pageid" element={<SettingmasterView />} />
				<Route path="/settingmaster/add" element={<SettingmasterAdd />} />
				<Route path="/settingmaster/edit/:pageid" element={<SettingmasterEdit />} />

				{/* smstempetes pages routes */}
				<Route path="/smstempetes" element={<SmstempetesList />} />
				<Route path="/smstempetes/:fieldName/:fieldValue" element={<SmstempetesList />} />
				<Route path="/smstempetes/index/:fieldName/:fieldValue" element={<SmstempetesList />} />
				<Route path="/smstempetes/view/:pageid" element={<SmstempetesView />} />
				<Route path="/smstempetes/add" element={<SmstempetesAdd />} />
				<Route path="/smstempetes/edit/:pageid" element={<SmstempetesEdit />} />

				{/* states pages routes */}
				<Route path="/states" element={<StatesList />} />
				<Route path="/states/:fieldName/:fieldValue" element={<StatesList />} />
				<Route path="/states/index/:fieldName/:fieldValue" element={<StatesList />} />
				<Route path="/states/view/:pageid" element={<StatesView />} />
				<Route path="/states/add" element={<StatesAdd />} />
				<Route path="/states/edit/:pageid" element={<StatesEdit />} />

				{/* subareamaster pages routes */}
				<Route path="/subareamaster" element={<SubareamasterList />} />
				<Route path="/subareamaster/:fieldName/:fieldValue" element={<SubareamasterList />} />
				<Route path="/subareamaster/index/:fieldName/:fieldValue" element={<SubareamasterList />} />
				<Route path="/subareamaster/view/:pageid" element={<SubareamasterView />} />
				<Route path="/subareamaster/add" element={<SubareamasterAdd />} />
				<Route path="/subareamaster/edit/:pageid" element={<SubareamasterEdit />} />

				{/* tt pages routes */}
				<Route path="/tt" element={<TtList />} />
				<Route path="/tt/:fieldName/:fieldValue" element={<TtList />} />
				<Route path="/tt/index/:fieldName/:fieldValue" element={<TtList />} />

				{/* unitmaster pages routes */}
				<Route path="/unitmaster" element={<UnitmasterList />} />
				<Route path="/unitmaster/:fieldName/:fieldValue" element={<UnitmasterList />} />
				<Route path="/unitmaster/index/:fieldName/:fieldValue" element={<UnitmasterList />} />
				<Route path="/unitmaster/view/:pageid" element={<UnitmasterView />} />
				<Route path="/unitmaster/add" element={<UnitmasterAdd />} />
				<Route path="/unitmaster/edit/:pageid" element={<UnitmasterEdit />} />

				{/* users pages routes */}
				<Route path="/users" element={<UsersList />} />
				<Route path="/users/:fieldName/:fieldValue" element={<UsersList />} />
				<Route path="/users/index/:fieldName/:fieldValue" element={<UsersList />} />
				<Route path="/users/view/:pageid" element={<UsersView />} />
				<Route path="/users/add" element={<UsersAdd />} />
				<Route path="/users/edit/:pageid" element={<UsersEdit />} />

				{/* vwclosingbalance pages routes */}
				<Route path="/vwclosingbalance" element={<VwclosingbalanceList />} />
				<Route path="/vwclosingbalance/:fieldName/:fieldValue" element={<VwclosingbalanceList />} />
				<Route path="/vwclosingbalance/index/:fieldName/:fieldValue" element={<VwclosingbalanceList />} />
				<Route path="/vwclosingbalance/branch_list" element={<VwclosingbalanceBranchlist />} />
				<Route path="/vwclosingbalance/branch_list/:fieldName/:fieldValue" element={<VwclosingbalanceBranchlist />} />

				{/* vwdemandcollectionbyperiod pages routes */}
				<Route path="/vwdemandcollectionbyperiod" element={<VwdemandcollectionbyperiodList />} />
				<Route path="/vwdemandcollectionbyperiod/:fieldName/:fieldValue" element={<VwdemandcollectionbyperiodList />} />
				<Route path="/vwdemandcollectionbyperiod/index/:fieldName/:fieldValue" element={<VwdemandcollectionbyperiodList />} />

				{/* vwjournals pages routes */}
				<Route path="/vwjournals" element={<VwjournalsList />} />
				<Route path="/vwjournals/:fieldName/:fieldValue" element={<VwjournalsList />} />
				<Route path="/vwjournals/index/:fieldName/:fieldValue" element={<VwjournalsList />} />

				{/* vwjournalsall pages routes */}
				<Route path="/vwjournalsall" element={<VwjournalsallList />} />
				<Route path="/vwjournalsall/:fieldName/:fieldValue" element={<VwjournalsallList />} />
				<Route path="/vwjournalsall/index/:fieldName/:fieldValue" element={<VwjournalsallList />} />

				{/* vwloantransaction pages routes */}
				<Route path="/vwloantransaction" element={<VwloantransactionList />} />
				<Route path="/vwloantransaction/:fieldName/:fieldValue" element={<VwloantransactionList />} />
				<Route path="/vwloantransaction/index/:fieldName/:fieldValue" element={<VwloantransactionList />} />

				{/* vwmaxloanaccount pages routes */}
				<Route path="/vwmaxloanaccount" element={<VwmaxloanaccountList />} />
				<Route path="/vwmaxloanaccount/:fieldName/:fieldValue" element={<VwmaxloanaccountList />} />
				<Route path="/vwmaxloanaccount/index/:fieldName/:fieldValue" element={<VwmaxloanaccountList />} />

				{/* vwonetimeoverduepreview pages routes */}
				<Route path="/vwonetimeoverduepreview" element={<VwonetimeoverduepreviewList />} />
				<Route path="/vwonetimeoverduepreview/:fieldName/:fieldValue" element={<VwonetimeoverduepreviewList />} />
				<Route path="/vwonetimeoverduepreview/index/:fieldName/:fieldValue" element={<VwonetimeoverduepreviewList />} />

				{/* vwtrialbalance pages routes */}
				<Route path="/vwtrialbalance" element={<VwtrialbalanceList />} />
				<Route path="/vwtrialbalance/:fieldName/:fieldValue" element={<VwtrialbalanceList />} />
				<Route path="/vwtrialbalance/index/:fieldName/:fieldValue" element={<VwtrialbalanceList />} />

				{/* workerlatestlocation pages routes */}
				<Route path="/workerlatestlocation" element={<WorkerlatestlocationList />} />
				<Route path="/workerlatestlocation/:fieldName/:fieldValue" element={<WorkerlatestlocationList />} />
				<Route path="/workerlatestlocation/index/:fieldName/:fieldValue" element={<WorkerlatestlocationList />} />
				<Route path="/workerlatestlocation/view/:pageid" element={<WorkerlatestlocationView />} />
				<Route path="/workerlatestlocation/add" element={<WorkerlatestlocationAdd />} />
				<Route path="/workerlatestlocation/edit/:pageid" element={<WorkerlatestlocationEdit />} />

				{/* workerlocations pages routes */}
				<Route path="/workerlocations" element={<WorkerlocationsList />} />
				<Route path="/workerlocations/:fieldName/:fieldValue" element={<WorkerlocationsList />} />
				<Route path="/workerlocations/index/:fieldName/:fieldValue" element={<WorkerlocationsList />} />
				<Route path="/workerlocations/view/:pageid" element={<WorkerlocationsView />} />
				<Route path="/workerlocations/add" element={<WorkerlocationsAdd />} />
				<Route path="/workerlocations/edit/:pageid" element={<WorkerlocationsEdit />} />
				<Route path="/nozone" element={<NozonePage />} />
				<Route path="/ledgerstatement" element={<LedgerstatementPage />} />
				<Route path="/enachauth" element={<EnachauthPage />} />
				<Route path="/loanschedue" element={<LoanscheduePage />} />
				<Route path="/loanledger" element={<LoanledgerPage />} />
				<Route path="/generajournal" element={<GenerajournalPage />} />
				<Route path="/trialbalance" element={<TrialbalancePage />} />
				<Route path="/balancesheet" element={<BalancesheetPage />} />
				<Route path="/profit" element={<ProfitPage />} />
				<Route path="/loanaeing" element={<LoanaeingPage />} />
				<Route path="/leavecaendar" element={<LeavecaendarPage />} />
				<Route path="/kycupdate" element={<KycupdatePage />} />
				<Route path="/geodashboard" element={<GeodashboardPage />} />
				<Route path="/journalent" element={<JournalentPage />} />
				<Route path="/debitpresentation" element={<DebitpresentationPage />} />
				<Route path="/debitverify" element={<DebitverifyPage />} />
				<Route path="/mandateverify" element={<MandateverifyPage />} />
				<Route path="/sms_alert" element={<SmsAlertPage />} />
				<Route path="/sms_notreceive" element={<SmsNotreceivePage />} />
				<Route path="/sms_received" element={<SmsReceivedPage />} />
				<Route path="/demandcollectionreport" element={<DemandcollectionreportPage />} />
				<Route path="/collection" element={<CollectionPage />} />
				<Route path="/emistatus" element={<EmistatusPage />} />
				<Route path="/emicollectionstatus" element={<EmicollectionstatusPage />} />
				<Route path="/vemicalculator" element={<VemicalculatorPage />} />
				<Route path="/cashflow" element={<CashflowPage />} />
				<Route path="/overduechargeposting" element={<OverduechargepostingPage />} />
				<Route path="/uploadexcel" element={<UploadexcelPage />} />
				<Route path="/bm" element={<BmPage />} />
				<Route path="/reschedule" element={<ReschedulePage />} />
				<Route path="/account/*" element={<AccountPages />} />
			</Route>
			</Route>
			<Route exact element={<IndexLayout />}>
				<Route path="/" element={<DefaultPage />} />
				<Route path="/*" element={<IndexPages />} />
				<Route path="/error/*" element={<ErrorPages />} />
			</Route>
		</Routes>
	);
}
export default App;
